import React from 'react';
import { Users, Building, User, Star, Filter } from 'lucide-react';

export const ContactFilter = ({ activeCategory, onCategoryChange, contactCounts }) => {
  const filterOptions = [
    { id: 'all', label: 'All Contacts', icon: Filter, count: contactCounts.all, color: 'bg-gray-100 text-gray-700' },
    { id: 'users', label: 'Portal Users', icon: Users, count: contactCounts.users, color: 'bg-blue-100 text-blue-700' },
    { id: 'party', label: 'Party Members', icon: Building, count: contactCounts.party, color: 'bg-green-100 text-green-700' },
    { id: 'personal', label: 'Personal', icon: User, count: contactCounts.personal, color: 'bg-purple-100 text-purple-700' },
    { id: 'favourites', label: 'Favourites', icon: Star, count: contactCounts.favourites, color: 'bg-yellow-100 text-yellow-700' },
  ];

  return (
    <div className="">
      <div className="flex flex-wrap gap-2">
        {filterOptions.map((option) => {
          const Icon = option.icon;
          const isActive = activeCategory === option.id;
          
          return (
            <button
              key={option.id}
              onClick={() => onCategoryChange(option.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-all card-wrapper ${
                isActive
                  ? `${option.color} ring-2 ring-offset-2 ring-current`
                  : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Icon className="w-4 h-4" />
              <span>{option.label}</span>
              <span
                className={`px-2 py-0.5 text-xs rounded-full ${
                  isActive ? 'bg-white/20' : 'bg-gray-200 text-gray-600'
                }`}
              >
                {option.count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
